module.exports = __webpack_public_path__ + "static/media/sample15.f9d7c73d.jpg";